import { moduleProviderFactory } from "mrb/core";
import { NakiNigunImportBatchList, NakiNigunImportBatchPreview } from "administration/naki-nigun-import/pages";
import {
    NakiNigunImportBatchListRouteStore,
    NakiNigunImportBatchPreviewRouteStore,
} from "administration/naki-nigun-import/stores";

(function () {
    moduleProviderFactory.module("administration").register({
        name: "NakiNigunImport",
        routes: [
            {
                name: "master.administration.naki-nigun-import.batch",
                pattern: "/naki-nigun-import",
                children: [
                    {
                        name: "master.administration.naki-nigun-import.batch.list",
                        pattern: "",
                        component: NakiNigunImportBatchList,
                        store: NakiNigunImportBatchListRouteStore,
                        data: {
                            title: "ADMINISTRATION.NAKI_NIGUN_IMPORT.LIST.TITLE",
                        },
                    },
                    {
                        name: "master.administration.naki-nigun-import.batch.preview",
                        pattern: "/:id",
                        // STUB — Task P3 implements the full preview page/store; see
                        // administration/naki-nigun-import/pages/NakiNigunImportBatchPreview.jsx.
                        component: NakiNigunImportBatchPreview,
                        store: NakiNigunImportBatchPreviewRouteStore,
                        data: {
                            title: "ADMINISTRATION.NAKI_NIGUN_IMPORT.PREVIEW.TITLE",
                        },
                    },
                ],
            },
        ],
        menu: [
            {
                title: "ADMINISTRATION.MENU.NAKI_NIGUN_IMPORT",
                order: 16,
                icon: "nigun",
                route: "master.administration.naki-nigun-import.batch.list",
            },
        ],
    });
})();
